module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "ack"
    }
  }, [_c('p', {
    staticClass: "Chapter-Name-1"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI"
  }, [_vm._v("I want to start by thanking my amazing husband for always encouraging me to follow my dreams, pushing me to believe in myself, and supporting my journey. I want to thank my kids, biological and bonus; if it wasn’t for them, I wouldn’t have the experience to write a parenting book. A "), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("huge")]), _vm._v(" thanks to my publisher, Milli—thank you for seeing my potential and being my corner man. Finally, to my editing team, y’all make a girl look good.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5fb67f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ack.vue
// module id = 72
// module chunks = 0